const UserApiEndpoint = {
    GET_USER_DETAILS: '/user',
    UPDATE_PERSONAL_INFO: '/user/personal-info',
    UPDATE_USER_AGREEMENT_INFO: '/user/agreement',
    UPDATE_USER_PROFILE: '/refresh-citizenship',
    GET_BUDGET: '/budget',
    GET_DEBT_INFO: '/transactions/debt-summary',
    GET_PURCHASES: '/transactions',
    GET_TRANSACTION_DETAIL: '/transactions/:transactionId',
    GET_DUE_INSTALLMENTS: '/transactions/due-installments',
    GET_DUE_INSTALLMENT_BY_ID:
        '/transactions/:transactionId/installments/:installmentId',
    GET_CAMPAIGNS: '/campaigns',
    UPDATE_PHONE_NUMBER: '/user/phone-number',
    VERIFY_PHONE_NUMBER: '/user/verify-phone-number',
    RESEND_OTP_CODE: '/user/phone-number/resend',
    UPDATE_EMAIL: '/user/email',
    DEACTIVATE_ACCOUNT: '/deactivate',
    SAVED_CARDS: '/user/saved-cards',
    GET_SAVED_CARD_BY_ID: '/user/saved-cards/card/:cardId',
    CHECK_AGREEMENT: '/user/agreement',
    SET_AS_DEFAULT_CARD: '/user/saved-cards/:id/default',
    DELETE_CARD: '/user/saved-cards/:id',
    HEALTH_CHECK: '/health-check',
};

export default UserApiEndpoint;
